export interface EnvironmentInfo {
  userAgent: string;
  pageOrigin: string;
  hardwareConcurrency: number;
  /** Chromium-only browser estimates (capped/rounded); null elsewhere. */
  connection: { type?: string; effectiveType?: string; downlink?: number; rtt?: number } | null;
}

interface NetworkInformationLike {
  type?: string;
  effectiveType?: string;
  downlink?: number;
  rtt?: number;
}

export function captureEnvironment(): EnvironmentInfo {
  const connection = (navigator as Navigator & { connection?: NetworkInformationLike }).connection;
  return {
    userAgent: navigator.userAgent,
    pageOrigin: location.origin,
    hardwareConcurrency: navigator.hardwareConcurrency,
    connection: connection
      ? {
          type: connection.type,
          effectiveType: connection.effectiveType,
          downlink: connection.downlink,
          rtt: connection.rtt,
        }
      : null,
  };
}

export function newRunId(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}
